import { Col, Row } from 'react-styled-flexboxgrid';

import { AdjustedSection } from './styles';
import CtaSection from '@/components/CtaSection';
import PageHeadline from '@/components/ui/elements/PageHeadline';
import PropTypes from 'prop-types';
import ResponsiveGrid from '@/components/ui/ResponsiveGrid';
import ServicesSection from '@/components/Services/Section';

export const ServiceList = ({ heading, services = [], bottomCta }) => {
  return (
    <>
      <AdjustedSection>
        <ResponsiveGrid>
          <header>
            <Row>
              <Col xs={12}>
                <PageHeadline>{heading}</PageHeadline>
              </Col>
            </Row>
          </header>
        </ResponsiveGrid>
        {services.map((serviceSection) => (
          <ServicesSection key={serviceSection.heading} {...serviceSection} />
        ))}
      </AdjustedSection>
      <CtaSection bottomCta={bottomCta} />
    </>
  );
};

ServiceList.propTypes = {
  title: PropTypes.string.isRequired,
  services: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      backgroundImage: PropTypes.object.isRequired,
      description: PropTypes.array.isRequired,
      skills: PropTypes.arrayOf(
        PropTypes.shape({
          heading: PropTypes.string.isRequired,
          description: PropTypes.array.isRequired,
        }),
      ),
    }),
  ),
};

export default ServiceList;
